import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeWorkTermsModalComponent } from './change-work-terms-modal.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ReturnAgeOfCelebrantModule} from "../../../../../pipes/returnAgeOfCelebrant/return-age-of-celebrant.module";

@NgModule({
  declarations: [
    ChangeWorkTermsModalComponent
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ReturnAgeOfCelebrantModule
    ],
  exports: [ChangeWorkTermsModalComponent]
})
export class ChangeWorkTermsModalModule { }
